<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: { DatePicker },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            credit: 0,
            form: {
                id: '',
                check_id: '',
                reference: '',
                date: '',
                amount: '',
                description: '',
                file: '',
                is_credit: '',
                credit: '',
                bank_id: '',
                type_payment: '',
                checkbook_id: '',
                folio: '',
            },
            company_id: '',
            user_id: '',
            file: '',
            fileName: '',
            send: false,
        }
    },
    methods: {
        async getFolioCheckbook() {                       
            if (!this.form.checkbook_id) {
                this.form.folio = '';
                return;
            }
        
            await this.catalogue.getFoliosCheckbooks(this.form.checkbook_id, this.form.folio);
        },
        closedModal() {
            this.form.id = ''
            this.form.check_id = '';
            this.form.date = '';
            this.form.amount = '';
            this.form.reference = '';
            this.form.description = '';
            this.form.file = '';
            this.form.is_credit = '';
            this.form.credit = '';
            this.form.bank_id = '';
            this.file = '';
            this.fileName = '';
            this.user_id = '';
            this.company_id = "";
            this.form.folio = '';
            this.form.type_payment = '';
            this.form.checkbook_id = '';
            this.send = false;
            this.$modal.hide('addPays');
        },
        catch_file(event) {
            this.form.file = event.target.files[0];
            this.fileName = event.target.files[0].name;
        },
        async getCredit() {
            let _endpoint = '/credit_bill?user_id=' + this.user_id;
            let { data } = await request.get(_endpoint)
            this.credit = data;
        },
        async saveBuildings() {
            this.send = true;
            const data_form = new FormData();
            data_form.append('id', this.form.id)
            data_form.append('check_id', this.form.check_id)
            data_form.append('date', this.form.date)
            data_form.append('amount', this.form.amount)
            data_form.append('description', this.form.description)
            data_form.append('file', this.form.file)
            data_form.append('reference', this.form.reference)
            data_form.append('is_credit', this.form.is_credit ? 1 : 0)
            data_form.append('credit', this.form.credit)
            data_form.append('bank_id', this.form.bank_id)
            data_form.append('type_payment', this.form.type_payment)
            data_form.append('checkbook_id', this.form.checkbook_id)
            data_form.append('folio', this.form.folio)

            data_form.append('_method', 'POST');

            if (this.form.date) {
                let dt = this.moment(this.form.date).format("YYYY-MM-DD");
                data_form.append('date', dt);
            }

            let _endpoint = '/pays';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/pays/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    console.log(data);
                    // this.users = data.data;
                    this.successNotification(data.message);
                    this.closedModal();
                    // Event.$emit('event-load-checks');
                    Event.$emit('event-load-pays');
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-addPays", async (check, account = null) => {
            console.log(check);
            console.log(account);
            this.user_id = check.user_id;
            await this.getCredit();
            this.form.check_id = check.id;
            this.form.amount = check.amount_payable;
            this.form.type_payment = check.type_payment_id;
            if(check.tax){
                await this.catalogue.getBankAccountCompany(check.tax.company_id);
                this.catalogue.get_checkbooks_company(check.tax.company_id);
            }
            if (check.bill) {
                this.catalogue.get_checkbooks_company(check.bill.company_id);
                this.company_id = check.bill.company_id;
                await this.catalogue.getBankAccountCompany(this.company_id);
                let bancks = await this.catalogue.bank_account_company;
                if (bancks.length == 1) {
                    this.form.bank_id = bancks[0].id;
                }
            }
            if (check.pay_roll) {
                this.catalogue.get_checkbooks_company(check.pay_roll.company_id);
                this.company_id = check.pay_roll.company_id;
                await this.catalogue.getBankAccountCompany(check.pay_roll.company_id);
                let bancks = await this.catalogue.bank_account_company;
                if (bancks.length == 1) {
                    this.form.bank_id = bancks[0].id;
                }
            }
            if (check.share) {
                this.catalogue.get_checkbooks_company(check.share.company_id);
                this.company_id = check.share.company_id;
                await this.catalogue.getBankAccountCompany(this.company_id);
                let bancks = await this.catalogue.bank_account_company;
                if (bancks.length == 1) {
                    this.form.bank_id = bancks[0].id;
                }
            }
            this.form.date = this.moment(check.date).toDate();

            if (account.id) {
                this.form.id = account.id;
                this.form.reference = account.reference;
                this.form.amount = account.amount;
                this.form.description = account.description;
                this.form.is_credit = account.is_credit;
                this.form.credit = account.credit;
                this.form.bank_id = account.bank_id;
                this.form.type_payment = account.type_payment;
                this.form.checkbook_id = account.checkbook_id;
                this.form.folio = account.folio;      
                
                if (account.checkbook_id) {
                    await this.getFolioCheckbook();
                }

                if (account.date) {
                    let dt = this.moment(account.date).toDate();
                    this.form.date = dt;
                }
                if (account.file) {
                    this.file = account.file;
                }
            }
            this.$modal.show('addPays');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    mounted() {
        this.catalogue.get_type_payments();        
    }
}
</script>
<template>
    <modal name="addPays" :width="'80%'" :scrollable="true" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información Pago</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-6 mt-3">
                        <label>Fecha</label><br>
                        <date-picker format="YYYY-MM-DD" :disabled="!prop_edit" v-model="form.date"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Monto</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Tipo de saldo</label>
                        <select type="text" :disabled="!prop_edit" class="form-control" v-model="form.type_payment">
                            <option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
                                :value="type_payment.id" :key="index_type_payment">{{
        type_payment.name }}</option>
                        </select>
                        <div v-if="errors && errors.type_payment" class="text-danger">{{ errors.type_payment[0] }}
                        </div>
                    </div>

                    <!-- <div class="col-md-6 mt-3">
                        <label>Pago con notas crédito</label>
                        <input type="checkbox" class="form-control form-control-sm" value="1"  :disabled="!prop_edit"  v-model="form.is_credit">                        
                        <div v-if="errors && errors.is_credit" class="text-danger">{{ errors.is_credit[0] }}</div>
                    </div> 
                    <div class="col-md-8 mt-3" v-if="form.is_credit == 1">
                        <label>Monto con crédito</label>
                        <money :disabled="!prop_edit || credit == 0"  class="form-control" v-model="form.credit"></money>
                        <div class="text-info"> La suma de notas de crédito es: {{ credit | toCurrency }}</div>                        
                        <div v-if="errors && errors.credit" class="text-danger">{{ errors.credit[0] }}</div>
                    </div>                     -->
                    <div class="col-md-6 mt-3">
                        <label>Referencia</label>
                        <input :disabled="!prop_edit" class="form-control" v-model="form.reference" />
                        <div v-if="errors && errors.reference" class="text-danger">{{ errors.reference[0] }}</div>
                    </div>
                    <div class="col-md-12 mt-3" v-if="form.type_payment != 6">
                        <label>Cuenta de banco</label>
                        <select v-model="form.bank_id" class="form-control">
                            <option value=""> Sin cuentas</option>
                            <option :value="bank.id" v-for="(bank, index) in catalogue.bank_account_company"
                                :key="index">
                                <span v-if="bank.bank">
                                    {{ bank.bank.name }}</span> - {{ bank.number }}
                            </option>
                        </select>
                        <div v-if="errors && errors.bank_id" class="text-danger">{{ errors.bank_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="form.type_payment == 6">
                        <label>Cheque</label>
                        <select v-model="form.checkbook_id" class="form-control" @change="getFolioCheckbook()">
                            <option value=""> Sin chequera</option>
                            <option :value="checkbook.id" v-for="(checkbook, index) in catalogue.checkbooks"
                                :key="index">
                                <span v-if="checkbook.bank">
                                    {{ checkbook.bank.name }} -
                                </span>
                                {{ checkbook.name }} {{ checkbook.id_ini }} / {{ checkbook.id_end }}
                            </option>
                        </select>
                        <div v-if="errors && errors.checkbook_id" class="text-danger">{{ errors.checkbook_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3" v-if="form.type_payment == 6">
                        <label>Folio</label>
                        <select type="text" class="form-control" v-model="form.folio" :disabled="!prop_edit">   
                            <option value=""> Sin folio</option>
                            <option v-for="(folio, index) in catalogue.folios_checkbooks" :value="folio" :key="index">
                                {{ folio }}
                            </option>

                        </select>
                        <div v-if="errors && errors.folio" class="text-danger">{{ errors.folio[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Descripción</label>
                        <textarea type="text" :disabled="!prop_edit" class="form-control"
                            v-model="form.description"></textarea>
                        <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Archivo</label><br>
                        <div class="custom-file" :style="file != '' ? 'width: 87%' : 'width: 100%'">
                            <input type="file" :disabled="!prop_edit" class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''" id="customFile" ref="file" @change="catch_file">
                            <label class="custom-file-label text-left" for="customFile">{{ fileName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${file}`" v-if="file != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.file" class="text-danger">{{ errors.file[0] }}</div>

                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>